import { Vue, Component, Watch } from "vue-property-decorator";
import store from "@/store";
import WebLoginAccount from "@/interfaces/WebLogin/WebLoginAccount";
import EmployeeSecurity from "@/enumerations/Security/EmployeeSecurity";
import GeneralSecuritySettings from "@/helpers/Security/GeneralSecuritySettings";

@Component
export default class AccountMonitorMixin extends Vue {
  async loadData(): Promise<void> {
    //calls the loadData function in the component using this mixin
  }

  /** Used to perform any necessary logic when an account changes. */
  accountChanged(): void {
    //calls the accountChanged function in the component using this mixin
  }

  get selectedAccount() {
    return store.getters.webLoginModule.selectedAccount;
  }

  get webLogin() {
    return store.getters.webLoginModule.webLogin;
  }

  @Watch("selectedAccount")
  selectedAccountChanged(
    newValue: WebLoginAccount,
    oldValue: WebLoginAccount
  ): void {
    const generalSecuritySettings = GeneralSecuritySettings.getInstance();
    if (
      generalSecuritySettings.manager &&
      !(newValue.id && oldValue.id) &&
      this.$router.currentRoute.path !== "/home"
    ) {
      // manager switching from manager account to customer account or vice versa
      // push to home page as a manager account sees different pages/menu options vs a customer account
      this.$router.push("/home");
    } else if (
      store.getters.webLoginModule.webLogin.isEmployee &&
      store.getters.webLoginModule.webLogin.employeeSecurity ===
        EmployeeSecurity.userProfile &&
      oldValue.isAccountLinkedToWebLogin &&
      !newValue.isAccountLinkedToWebLogin
    ) {
      // employee switching from linked account to non-linked account
      // refresh page to make router re-evaluate route security access
      location.reload();
    } else {
      this.accountChanged();
      this.loadData();
    }
  }
}
